<list-view *ngIf="listeStatuts" [liste]="listeStatuts"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>